import React, { useState, useContext, useEffect, useRef } from "react";
import EmailIcon from "../../Assets/Images/EmailIcon.svg";
import PassIcon from "../../Assets/Images/PassIcon.svg";
import Message from "../Message/Message";
import { NavLink } from "react-router-dom";
import Validate from "./validate";
import useLogin from "./useLogin";
import { ThemeDataContext } from "../../ContextProviders/theme";
import mark from "../../Assets/Images/exclamation-circle.svg";
import { useMediaQuery } from "react-responsive";

import "./SignInFormAtlantica.css";
import { BsEyeFill } from "react-icons/bs";
import CheckboxVerity from "../Checkbox/CheckboxVerity";
import toast, { Toaster, useToaster, useToasterStore } from "react-hot-toast";
import Exclamation from "../../Icons/Exclamation";
import { BsExclamationCircle } from "react-icons/bs";

export function SignInForm() {
    const {
        handleChange,
        handleSubmit,
        values,
        errors,
        authErrors,
        setAuthErrors,
    } = useLogin(Validate);

    const Tablet = useMediaQuery({
        query: "(min-width: 768px) ",
    });

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const { portalInfo } = useContext(ThemeDataContext) || {};

    const { buttonBackgroundColor } = portalInfo || {};
    const { buttonColor } = portalInfo || {};

    const programLabel = localStorage.getItem("programLabel");

    const buttonStyle = {
        backgroundColor: `${buttonBackgroundColor}`,
        color: `${buttonColor}`,
    };
    const linkStyle = {
        color: `${buttonBackgroundColor}`,
    };

    const notifyError = () =>
        toast(
            <div
                style={{
                    display: "flex",
                    width: "100%",

                    borderRadius: "7px",
                    fontFamily: "Lato",
                    filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))",
                    background: "transparent",
                    color: `black`,

                    // padding: '0.7rem',

                    // flexShrink: '0',
                }}
            >
                <div
                    style={{
                        display: "flex",
                        order: "1",
                        alignItems: "center",
                        width: "20%",
                        transform: "translateX(-10%)",
                    }}
                >
                    <Exclamation
                        width="50"
                        height="50"
                        viewBox="-4 1 25 15"
                        color="red"
                    />
                    {/* <BsExclamationCircle
            color='red'
            size='40'
         
          /> */}
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        order: "2",
                        width: "80%",
                        transform: "translateX(0%)",
                        // paddintTop: '20%',
                        // paddingBottom: '20%',
                    }}
                >
                    {authErrors}
                </div>
            </div>,

            {
                // icon: '????',
                style: {
                    borderLeft: "6.5px solid red",
                    maxWidth: "350px",
                },

                position: "top-center",
            },
        );
    // const getHeadingColor = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return 'white';
    //   }
    //   return 'var(--color-accent)';
    // };

    // const getBackgroundColor = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return 'transparent';
    //   }
    //   return 'white';
    // };

    // const getBorder = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return '2px solid white';
    //   }
    //   return 'none';
    // };

    // const getBorderRadius = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return '50px';
    //   }
    //   return 'none';
    // };
    // const getHeight = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return '50px';
    //   }
    //   return 'auto';
    // };
    // const getColor = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return 'white';
    //   }
    //   return 'var(--color-accent)';
    // };

    // const getEmailPlaceholder = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return `${''} ${''} ${''} ${''} ${''}  Email`;
    //   }
    //   return '';
    // };
    // const getPasswordPlaceholder = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return `${''} ${''} ${''} ${''} ${''}  Password`;
    //   }
    //   return '';
    // };

    // const getFillColor = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return 'white';
    //   }
    //   return 'grey';
    // };
    // const getEyeTransform = () => {
    //   if (programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA') {
    //     return 'translate(-150%, -18%)';
    //   }
    //   return 'translateX(-90%)';
    // };

    const { toasts, handlers } = useToaster();
    const { startPause, endPause, calculateOffset, updateHeight } = handlers;

    const TOAST_LIMIT = 1;

    useEffect(() => {
        console.log(toasts, "toasts");
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit?
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) for no exit animation
    }, [toasts]);

    // const notifyError = () => toast.error(authErrors);

    const handleDismiss = () => {
        toasts.forEach((t) => toast.dismiss(t.id));
    };

    const buttonRef = useRef();
    useEffect(() => {
        if (authErrors.length != 0) {
            notifyError();
            setAuthErrors([]);
            buttonRef.current.disabled = true;
            setTimeout(() => (buttonRef.current.disabled = false), 3000);
        }
    }, [authErrors, notifyError, buttonRef]);

    const [isDisabled, setIsDisabled] = useState(false);
    const enableComponents = () => {
        setIsDisabled(false);
        console.log(isDisabled, "isEnabled");
    };

    const handleSubmitClicked = () => {
        setIsDisabled(true);
        console.log(isDisabled, "isDisabled");
        setTimeout(() => enableComponents(), 2000);
    };

    return (
        <>
            <div className="p-4 d-flex flex-column align-items-center">
                <h1
                    // style={{ color: `${getHeadingColor()}` }}
                    id=""
                >
                    Welcome Back !
                </h1>

                <div onClick={handleDismiss}>
                    <Toaster
                        position="top-center"
                        containerClassName="SignInToaster"
                        containerStyle={{
                            top: 10,
                            left: 10,
                            bottom: 10,
                            right: 10,
                        }}
                    />
                </div>
            </div>
            <form
                className="d-flex flex-column align-items-center h-100 justify-content-around"
                onSubmit={handleSubmit}
            >
                <div className="d-flex flex-column">
                    <div className="mb-6">
                        <label htmlFor="email" id="signIn-email-Label">
                            <img
                                src={EmailIcon}
                                className="emailIcon"
                                alt="email"
                            />{" "}
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            name="email"
                            className="signIn-form-input"
                            value={values.email}
                            // placeholder={getEmailPlaceholder()}
                            onChange={handleChange}
                        />

                        {errors.email && (
                            <p className="signInErrors">{errors.email}</p>
                        )}
                    </div>
                    <div className="">
                        <label htmlFor="password" className="passLabel">
                            <img
                                src={PassIcon}
                                className="passIcon"
                                alt="password"
                            />
                            Password
                        </label>
                        <input
                            type={passwordShown ? "text" : "password"}
                            name="password"
                            id="password"
                            className="signIn-form-input"
                            value={values.password}
                            onChange={handleChange}
                        />
                        <BsEyeFill
                            className="signIn-eye"
                            fill="grey"
                            onClick={togglePassword}
                        />
                        {errors.password && (
                            <p className="signInErrors">{errors.password}</p>
                        )}
                    </div>
                </div>

                <div className="formButtonContainer">
                    <button
                        button={isDisabled}
                        ref={buttonRef}
                        style={buttonStyle}
                        className="formButton"
                        type="submit"
                        // onClick={notifyError2}
                        onClick={handleSubmitClicked}
                    >
                        Sign In
                    </button>
                </div>
                <div className="">
                    <div className="">
                        <div className="">
                            <label
                                // style={{ color: `${getColor()}` }}
                                htmlFor="rememberMe"
                                className="signIn-checkBoxLabel mr-2"
                            >
                                Remember Me
                            </label>
                            <CheckboxVerity
                                id="rememberMe"
                                type="checkbox"
                                name="rememberMe"
                                className="checkboxVerity"
                                checked={values.rembemberMe}
                                onChange={handleChange}
                                required={false}
                            />
                        </div>
                    </div>
                    <div className="">
                        <NavLink
                            style={linkStyle}
                            to="/signIn/forgotpassword"
                            className="forgotPassLink"
                        >
                            Forgot Password?
                        </NavLink>
                    </div>
                </div>
            </form>
        </>
    );
}

export default SignInForm;
